import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import {
  Session,
  useApplicationAnalytics,
  useSessionParticipationsStats,
} from '@app/api';
import { WithOverviewColumnLayout } from './components/WithOverviewColumnLayout';
import { ApplicationCounts } from './components/Stats/ApplicationCounts';
import { ApplicationFunnel } from './components/Stats/ApplicationFunnel';
import { FieldAnswersCount } from './components/Stats/FieldAnswersCounts';
import { ParticipationsCount } from './components/Stats/ParticipationsCount';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase * 3,
    flexWrap: 'wrap',
  },
}));

interface Props {
  session: Session;
}

export const Stats = ({ session }: Props) => {
  const classes = useStyles();

  const { data: applicationAnalytics = [] } = useApplicationAnalytics(
    session.id,
  );
  const { data: participationAnalytics = [] } = useSessionParticipationsStats(
    session.id,
  );

  return (
    <WithOverviewColumnLayout session={session}>
      <div className={classes.container}>
        <ApplicationCounts analytics={applicationAnalytics} />
        <ApplicationFunnel analytics={applicationAnalytics} />
        <ParticipationsCount
          analytics={participationAnalytics}
          studyType={session.studyType}
        />
        <FieldAnswersCount analytics={applicationAnalytics} session={session} />
      </div>
    </WithOverviewColumnLayout>
  );
};
